import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import clsx from "clsx";
import { AnimatePresence, motion } from "framer-motion";
import PropTypes from "prop-types";
import Odometer from "react-odometerjs";

import { currencyFormat } from "@lib/text.helpers";

import "./savings-display.scss";

export const SavingsDisplay = ({ savings = 0, adjustmentAmount }) => {
  return (
    <div className="savings-display">
      <div className="adjustment-amount-container">
        <AnimatePresence>
          {adjustmentAmount && (
            <motion.div
              className={clsx("adjustment-amount", {
                increase: adjustmentAmount > 0,
                deduct: adjustmentAmount < 0,
              })}
              initial={{ opacity: 0, y: "1.25rem" }}
              animate={{
                opacity: 1,
                y: 0,
                transition: { type: "spring", bounce: 0.5, duration: 0.3 },
              }}
              exit={{ opacity: 0, y: "-1.25rem" }}
            >
              {adjustmentAmount > 0 && "+"}
              {currencyFormat(adjustmentAmount)}
            </motion.div>
          )}
        </AnimatePresence>
      </div>

      <motion.div
        className={clsx("savings-amount", {
          increase: adjustmentAmount > 0,
          deduct: adjustmentAmount < 0,
        })}
        initial={{ scale: 0.9, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.3 }}
      >
        <FontAwesomeIcon icon={["fa-solid", "piggy-bank"]} />
        <span>
          $
          <Odometer value={savings} format="(,ddd)" duration={250} />
        </span>
      </motion.div>
    </div>
  );
};

SavingsDisplay.propTypes = {
  savings: PropTypes.number,
  adjustmentAmount: PropTypes.number,
};
